// extracted by mini-css-extract-plugin
export default {"container":"G2ojV","hovered":"s5JYu","vAlign--justify":"zhtZj","vAlign--top":"qelmN","vAlign--middle":"ea57K","vAlign--bottom":"oZ2PV","animation--hover":"cQSd7"};